// JavaScript Document
(function() {

	var $iq_apps = function($iq_http, $q, $iq_server,$iq_queue) {
		var res = {
			"appConfig":{
				url:"../configs.json",
					//$iq_server.server() + "modules/allowed/js",
				value:null,
				list:null
			},
			"appExtConfig":{//"../exconfigs.json",
				url:$iq_server.server() + "modules/allowed/js/extend",
				value:null,
				list:null,
			}
		}
		//http请求获取数据
		var httpReq = function(name){

			$iq_http.http({
					url : res[name].url,
					type : "json",
					method : "GET"
				}).then(function(value) {
					if (value.data.status == 2500) {
						$iq_queue.get(name).reject("数据错误");
						//def.reject("数据错误");
						return
					}
					var list = value.data;// 将后台传来的数据转为对象
					//var list =  (function(tmp){return Function("return "+tmp+"")()})(appconfigs);
					//var configs = {}
          //list.forEach(function(_this){
          //configs[_this.appCode] = _this;
          //})
					if(value.data.data!=undefined&&value.data.data!=""){
						res[name].value =  JSON.parse(value.data.data);
						res[name].list = JSON.parse(value.data.data);
					}
					$iq_queue.get(name).resolve(res[name].value);
				}, function(e) {
					$iq_queue.get(name).reject(res[name].value);
				});
		}
		var getAppConfig = function() {
      //var url = $iq_server.server() + "modules/allowed/js";
			// var url = "appconfig.json"
			if (res["appConfig"].value == null) {
				httpReq("appConfig");
			}
			return $iq_queue.get("appConfig").promise;
		}
		var getAppExtConfig = function(){

			// var url = "appconfig.json"
			if (res["appExtConfig"].value == null) {
				httpReq("appExtConfig");
			}
			return $iq_queue.get("appExtConfig").promise;
		}
		return {
			getAppConfig : getAppConfig,
			getAppExtConfig : getAppExtConfig,
			getAppConfigList : function() {
				return res["appConfig"].list;
			}
		}
	};

	var navigationService = function($q , $iq_http,$iq_server){
		var promise = null;

		//配置信息
		var configPrimise = null;

		var findNavs = function(){
			if (promise == null){
				var params = {
					method : "GET",
					url : $iq_server.server() + "/navigation/navigation-items"
				};
				promise = $iq_http.http(params);
			}
			return promise;
		};

		var saveNav = function(param){
			var params = {
				method : "POST",
				url :  $iq_server.server() + "/navigation/navigation-item",
				data : param,
				dataType : "json"
			};
			promise = null;
			return $iq_http.http(params);
		};

		var updateNav = function(param){
			var params = {
				method : "PUT",
				url :  $iq_server.server() + "/navigation/navigation-item",
				data : param,
				dataType : "json"
			}
			promise = null;
			return $iq_http.http(params);
		}

		return {
			findNavs : findNavs,
			saveNav : saveNav,
			updateNav : updateNav,
			getConfigRes :function(){
				if(configPrimise){
					return configPrimise;
				}
				var d = $q.defer();
				configPrimise = d.promise;
				findNavs().then(function(res){
					var list= res.data.data.modules.frontResource;
					var configs = {}
					list.forEach(function(_this){
						configs[_this.appCode] = _this;
					})
					d.resolve(configs);
				});
				return configPrimise;
			}
		}
	};

	var $iq_permission = function($iq_http, $q, $iq_server) {

		var limitTime = 5 * 60 * 1000; // 保留5分钟

		var url_matcher = new RegExp("^\\w[^\\\\/]+");

		var url = '' + $iq_server.server() + "is-permitted-all/";

		var permissionMap = {};

		/**
		 * 请求权限，如果有在请求的权限，返回之前请求的promise 如果超时、没有请求，请求后台，返回请求的promise
		 */
		var requestPermission = function(one) {
			if (one && angular.isString(one) && url_matcher.test(one)) {
				var _p = permissionMap[one]; // perimission对象
				if (_p) {
					if (_p.promise) { // 在请求时间内，返回请求的promise
						return _p.promise;
					} else if (permissionMap[one].timeStamp > new Date()
							- limitTime) { // 在缓存时间内，直接返回
						var def = $q.defer();
						def.resolve(permissionMap[one].value);
						return def.promise;
					}
				}
				// 没有有效的permission，请求后台
				var def = $q.defer();
				$iq_http.http({
							method : "get",
							url : url + one
						}).then(function(result) {
							var v = result.data;
							if (v === "true" || v === true) {
								permissionMap[one] = {
									value : true,
									timeStamp : new Date()
								};
								def.resolve(true);
							} else {
								permissionMap[one] = {
									value : false,
									timeStamp : new Date()
								};
								def.resolve(false);
							}
						}, function() {
							def.reject();
						})
				permissionMap[one] = {
					"promise" : def.promise
				};
				return permissionMap[one].promise;

			} else {
				var def = $q.defer();
				def.reject();
				return def.promise;
			}
		}
		/**
		 * 有列表中的任一权限,只要有其中一个权限，直接resolve(true) 全部没有返回resolve(false)
		 */
		var hasAny = function(list) {
			var def = $q.defer();
			if (angular.isArray(list)) { // 必须传入数组类型
				var total = list.length;
				for (var one in list) {
					requestPermission(list[one]).then(function(v) {
								if (v == true) {
									def.resolve(true);
								} else {
									total--;
									if (total <= 0) {
										def.resolve(false);
									}
								}
							}, function() {
								def.reject();
							})
				}
			} else {
				def.reject();
			}
			return def.promise;
		}
		/**
		 * 有所有列表中的权限,只要其中一个没权限，直接返回
		 */
		var hasAll = function(list) {
			var def = $q.defer();
			if (angular.isArray(list)) { // 必须传入数组类型
				var total = list.length;
				for (var one in list) {
					requestPermission(list[one]).then(function(v) {
								if (v == false) {
									def.resolve(false);
								} else {
									total--;
									if (total <= 0) {
										def.resolve(true);
									}
								}
							}, function() {
								def.reject();
							})
				}
			} else {
				def.reject();
			}
			return def.promise;
		}
		/**
		 * 有权限 注：后台方法也支持同时查询A,B权限，不分开查询，不过前台不在此做对接
		 */
		var has = function(permission) {
			return requestPermission(permission);
		}
		var clear = function() {
			permissionMap = {};
		}
		// 清楚指定的缓存
		var clearOne = function(one) {
			permissionMap[one] = undefined;
		}
		return {
			has : has,
			hasAny : hasAny,
			hasAll : hasAll,
			clearOne : clearOne
		}
	}
	var $iq_user = function($iq_server, $iq_config, $iq_http, $q, $iq_queue,
			$iq_httpError) {
		var userInfo = null;
		var orgInfo = {};

		var theme = "blue";
		var promise = undefined;
		var getUserInfo = function() {
			var def = $q.defer();
			if (userInfo != null) {
				def.resolve(userInfo);
				return def.promise;
			}
			if (promise) {
				return promise;
			}
			var url = $iq_server.server() + "login/user";
			var params = {
				method : "get",
				url : url
			}
			$iq_http.http(params).then(function(re) {
						if (re.data.success == true) {
							userInfo = re.data.data;
							if (userInfo.isTrialAccount == true) {
								$iq_httpError.loginUrl("/login/trial");
							}

							orgInfo.orgName = re.data.orgName;
							orgInfo.orgCode = re.data.orgCode;
							orgInfo.orgLogoColour = re.data.orgLogoColour;
							orgInfo.orgLogoWhite = re.data.orgLogoWhite;
							orgInfo.orgInnerEmailStatus = re.data.orgInnerEmailStatus;
							orgInfo.orgInnerEmailDomain = re.data.orgInnerEmailDomain;
							orgInfo.source = re.data.source;

							re.data.theme ? theme = re.data.theme : undefined;
							$iq_config.config({
										theme : theme
									})
							$iq_queue.get("logined").resolve(userInfo);

							def.resolve(userInfo);
						} else {
							def.reject(userInfo);
						}
					}, function() { // error func
						// 获取登录人信息失败

						def.reject(userInfo);
						promise = null;
					});
			promise = def.promise;
			return promise;
		}
		return {
			getTheme : function() {
				var def = $q.defer();
				if (userInfo != null) {
					def.resolve(theme);
					return def.promise;
				}
				getUserInfo().then(function() {
							def.resolve(theme);
						})
				return def.promise;
			},
			getUserInfo : getUserInfo,
			getOrgInfo : function() {
				var def = $q.defer();
				if (userInfo != null) {
					def.resolve(orgInfo);
					return def.promise;
				}
				getUserInfo().then(function() {
							def.resolve(orgInfo);
						})
				return def.promise;
			},
			refreshUser : function() {
				userInfo = null;
				return getUserInfo()
			},
			setUserSetting : function(userInfo) {
				userInfo = userInfo;
			}
		}
	}
  	/*
  	 * 获取用户信息并缓存的service author:zhangwen
  	 */
  	// 保存公司用户信息的全局变量/数组
	var alluserInfo = [];
	var $iq_getUserinfo = function($iq_server, $iq_config, $iq_http, $q,
			$iq_queue) {
		// 声明一个对象,包含请求回来的所有信息
		var allInfo = null;
		// 声明一个空的promise对象
		var promise = undefined;
		// 获取用户信息的函数
		var getUsersinfo = function() {

			// 如果已经存在信息，则直接返回
			if (alluserInfo.length != 0) {
				$iq_queue.get("user_cached").resolve(alluserInfo);
				return $iq_queue.get("user_cached").promise;
			}
			// 如果promise不为空，直接返回
			if (promise) {
				return promise;
			}
			// 请求的url
			var url = $iq_server.server() + 'persons';
			// 请求的参数
			var params = {
				method : "get",
				url : url,
				params : {
					'format_filter_person' : '3',
					'search_EQ_status' : '1',
					'sort' : 'ASC_pinyin',
					'pageSize':40,
					'up_executive':1
				}
			}

			// 发起http请求
			$iq_http.http(params).then(function(re) {
						// 如果请求成功，将userInfo信息赋值
						if (re.data.success == true) {
							allInfo = re.data.data;

							for (var i = 0; i < allInfo.content.length; i++) {

								// 取出id作为键
								var ids = allInfo.content[i].id;
								// 将另外两个属性作为值
								var temp = {
									'name' : allInfo.content[i].name,
									'phone' : allInfo.content[i].mobile
								};

								alluserInfo[ids]=temp;
							}


							$iq_queue.get("user_cached").resolve(alluserInfo);

						} else {
							$iq_queue.get("user_cached").reject(alluserInfo);
						}
					}, function() { // error func
						// 获取信息失败
						$iq_queue.get("user_cached").reject(alluserInfo);
						promise = null;
					});

			promise = $iq_queue.get("user_cached").promise;

			return promise;
		}

		return {

			getAllinfo : getUsersinfo
		}

	}

	var $iq_popup = function($iqmodal, $iq_http, $iq_server, $timeout,
			$iqmodal, $iq_popup_loadone) {
		// 遍历数组添加属性Flag=0
		var addFlag0 = function(data) {
			for (var i = 0; i < data.length; i++) {
				data[i].flag = 0;
			}
		}
		// 遍历数组添加属性Flag=1
		var addFlag1 = function(data) {
			for (var i = 0; i < data.length; i++) {
				data[i].flag = 1;
			}
		}
		// 遍历数组删除属性
		var delFlag = function(data) {
			for (var i = 0; i < data.length; i++) {
				delete data[i].flag;
			}
		}
		// 递归深度遍历部门数组获得节点
		var getallnode = function(data, getdata) {
			if(!data){
				return;
			}
			for (var i = 0; i < data.length; i++) {
				var tempdata = data[i];
				getdata.push(tempdata);
				if (tempdata.subDept && tempdata.subDept.length > 0) {
					getallnode(tempdata.subDept, getdata);
				}
			}
		}
		// 递归深度遍历部门数组,将data中的数据存储到restore，同时将data的id相同数据匹配到restore中相同数据
		var relinkDeptTree = function(deptData, restore) {
			if(!deptData){
				return;
			}
			for (var i = 0; i < deptData.length; i++) {
				var restoreDept = restore[deptData[i].id];
				var recursionFlag = true;
				if(restoreDept){
					if(restoreDept.subDept && restoreDept.subDept.length>0){
						//存储的值有子部门
						recursionFlag = false;
					}else{
						//没有子部门，直接从deptData赋值
						restoreDept.subDept = deptData[i].subDept;
					}
					deptData[i] = restoreDept;//让deptData中的对象等于存储对象
				}else{
					restoreDept = restore[deptData[i].id] = deptData[i];
				}
				//如果子部门是新赋值的，递归子部门
				if (recursionFlag && restoreDept.subDept && restoreDept.subDept.length > 0) {
					relinkDeptTree(restoreDept.subDept, restore);
				}
			}
		}
		var relinkPerson = function(personData, restore) {
			if(!personData){
				return;
			}
			for (var i = 0; i < personData.length; i++) {
				var restorePerson = restore[personData[i].id];
				var recursionFlag = true;
				if(restorePerson){
					personData[i] = restorePerson;//让personData中的对象等于存储对象
				}else{
					restorePerson = restore[personData[i].id] = personData[i];
				}
			}
		}
		var getallfilenode = function(data, getdata) {
			if(!data){
				return;
			}
			for (var i = 0; i < data.length; i++) {
				var tempdata = data[i];
				getdata.push(tempdata);
				if (tempdata.subDirs && tempdata.subDirs.length > 0) {
					getallfilenode(tempdata.subDirs, getdata);
				}
			}
		}
		// 遍历找标记位
		var findIndex = function(node, data) {
			if(!data){
				return;
			}
			for (var i = 0; i < data.length; i++) {
				if (node.id == data[i].id) {
					return i;
				}
			}
		}
		var my_alert = function(message, timeout, type) {
			if (angular.isUndefined(message)) {
				return;
			}
			var options = {
				message : message,
				timeout : timeout,
				type : type
			};
			var modalInstance = $iqmodal.open({
				// backdrop : "static",
				windowClass : 'modal mymodal alert-modal fail-modal success-modal',
				templateUrl : 'templates/common/iq_popupalert.html',
				resolve : {
					options : function() {
						return options;
					}
				},
				controller : function($scope, $modalInstance, $timeout, options) {
					$scope.options = angular.copy(options)
					$scope.type = 'success';
					if (options.timeout) {
						if (options.timeout == 'warn'
								| options.timeout == 'success'
								| options.timeout == 'fail') {
							$scope.type = options.timeout;
							$timeout(function() {
										$modalInstance.close('ok')
									}, 3000)
						} else {
							$timeout(function() {
										$modalInstance.close('ok')
									}, options.timeout + '000')
						}
					} else {
						$timeout(function() {
									$modalInstance.close('ok')
								}, 3000)
					}
					if (options.type) {
						$scope.type = options.type;
					}
					$scope.ok = function() {
						$modalInstance.close('ok');
					};
				}
			});

			modalInstance.opened.then(function() {
						$timeout(function() {
									$(".modal.mymodal").on(
											"click mouseup mousedown",
											function($event) {
												$event.stopPropagation();
											})
								})
					})
			return modalInstance.result;
		}


		var my_alert_invite = function(message, timeout, type) {
			if (angular.isUndefined(message)) {
				return;
			}
			var options = {
				message : message,
				timeout : timeout,
				type : type
			};
			var modalInstance = $iqmodal.open({
				// backdrop : "static",
				windowClass : 'modal alert-modal fail-modal success-modal',
				templateUrl : 'templates/common/iq_popupalert.html',
				resolve : {
					options : function() {
						return options;
					}
				},
				controller : function($scope, $modalInstance, $timeout, options) {
					$scope.options = angular.copy(options)
					$scope.type = 'success';
					if (options.timeout) {
						if (options.timeout == 'warn'
								| options.timeout == 'success'
								| options.timeout == 'fail') {
							$scope.type = options.timeout;
							$timeout(function() {
										$modalInstance.close('ok')
									}, 3000)
						} else {
							$timeout(function() {
										$modalInstance.close('ok')
									}, options.timeout + '000')
						}
					} else {
						$timeout(function() {
									$modalInstance.close('ok')
								}, 3000)
					}
					if (options.type) {
						$scope.type = options.type;
					}
					$scope.ok = function() {
						$modalInstance.close('ok');
					};
				}
			});

			modalInstance.opened.then(function() {
						$timeout(function() {
									$(".modal.mymodal").on(
											"click mouseup mousedown",
											function($event) {
												$event.stopPropagation();
											})
								})
					})
			return modalInstance.result;
		}


		var role_popup = function(selectdata, type, showtab) {
			var options = {
				selectdata : angular.copy(selectdata),
				type : type,
				showtab : showtab
			};
			var modalInstance = $iqmodal.open({
				backdrop : "static",
				windowClass : 'modal mymodal select-modal',
				templateUrl : $iq_server.client()
						+ 'templates/common/iq_popupRole.html',
				resolve : {
					options : function() {
						return options;
					}
				},
				controller : function($scope, $modalInstance, $iq_popup_loadone) {
					// 创建filter数据
					$scope.allFilter = '';
					// 新建回调数组
					$scope.datalist = [];
					if (options.selectdata) { // 如果传入了list
						$scope.datalist.push(options.selectdata);
					}
					// 判断单选时是否显示icheck
					$scope.multiple = true;
					if (options.type && options.type == 'single') {
						$scope.multiple = false;
					}

					// 点击切换tab事件
					$scope.tabchange = function(tab) {
						if (tab == 1) {
							$scope.tab1 = true;
							$scope.allFilter = ''; // 清空搜索项
							// 获取部门角色数据
							$scope.deptRoleData = [];
							$iq_popup_loadone
									.loadone('stations?&pageSize=999999999')
									.then(function(re) {
										$scope.deptRoleData = angular.copy(re);
										// 处理带入数据的选中状态
										if ($scope.datalist.length > 0) {
											for (var i = 0; i < $scope.deptRoleData.length; i++) {
												var nodeobj = $scope.deptRoleData[i];
												for (var j = 0; j < $scope.datalist.length; j++) {
													var withobj = $scope.datalist[j];
													if (withobj.id == nodeobj.id) {
														$scope
																.roleclick(nodeobj);
													}
												}
											}
										}
									}, function() {
										return;
									})
							// 点击添加到datalist数组
							$scope.roleclick = function(node) {
								if (options.type == 'single') {
									$scope.datalist.splice(0, 1, node);
								} else {
									if (node.flag == 1) {
										$scope.clearone(findIndex(node,
												$scope.datalist));
									} else {
										node.flag = 1;
										$scope.datalist.push(node);
									}
								}
							}
							// 点击ichech添加到datalist数组
							$scope.icheck = function(val) {
								if (val.flag == 0) {
									$scope.clearone(findIndex(val,
											$scope.datalist));
								} else if (val.flag == 1) {
									$scope.datalist.push(val);
								}
							}
						} else {
							$scope.tab1 = false;
						};
						if (tab == 2) {
							$scope.tab2 = true;
							$scope.allFilter = ''; // 清空搜索项
							// 获取公司角色数据
							$scope.companyRoleData = [];
							$iq_popup_loadone
									.loadone('roles?&pageSize=999999999').then(
											function(re) {
												$scope.companyRoleData = angular.copy(re);
												// 处理带入数据的选中状态
												if ($scope.datalist.length > 0) {
													for (var i = 0; i < $scope.companyRoleData.length; i++) {
														var nodeobj = $scope.companyRoleData[i];
														for (var j = 0; j < $scope.datalist.length; j++) {
															var withobj = $scope.datalist[j];
															if (withobj.id == nodeobj.id) {
																$scope
																		.rolenodeclick(nodeobj);
															}
														}
													}
												}
											}, function() {
												return;
											})
							// 点击添加到datalist数组
							$scope.rolenodeclick = function(node) {
								if (options.type == 'single') {
									$scope.datalist.splice(0, 1, node);
								} else {
									if (node.flag == 1) {
										$scope.clearone(findIndex(node,
												$scope.datalist));
									} else {
										node.flag = 1;
										$scope.datalist.push(node);
									}
								}
							}
							// 点击ichech添加到datalist数组
							$scope.icheck = function(val) {
								if (val.flag == 0) {
									$scope.clearone(findIndex(val,
											$scope.datalist));
								} else if (val.flag == 1) {
									$scope.datalist.push(val);
								}
							}
						} else {
							$scope.tab2 = false;
						}
					}

					// 判断显示哪个tab标签
					$scope.dept = false;
					$scope.company = false;
					if (options.showtab && options.showtab == 'showDept') {
						$scope.dept = true;
						$scope.tabchange(1)
					} else if (options.showtab
							&& options.showtab == 'showCompany') {
						$scope.company = true;
						$scope.tabchange(2)
					} else if (options.showtab
							&& options.showtab == 'showDeptCompany') {
						$scope.dept = true;
						$scope.company = true;
						$scope.tabchange(1)
					}
					// 清除单个
					$scope.clearone = function($index) {
						$scope.datalist[$index].flag = 0;
						$scope.datalist.splice($index, 1);
					}
					// 清除全部
					$scope.clearall = function() {
						addFlag0($scope.datalist)
						$scope.datalist = [];
					}

					// 点击确定和点击取消
					$scope.ok = function() {
						// 去掉flag属性
						delFlag($scope.datalist)
						$modalInstance.close($scope.datalist);
					}
					$scope.cancel = function() {
						$modalInstance.dismiss('cancel');
					}
					$scope.close = function() {
						$modalInstance.dismiss('close');
					};

				}
			})
			return modalInstance.result;
		}

		return {
			alert : my_alert,
			my_alert_invite : my_alert_invite,
			confirm : function(message, okButtonText, cancelButtonText) {
				var options = {
					message : message,
					okButtonText : okButtonText || '确定',
					cancelButtonText : cancelButtonText || '取消'
				};
				var _a = "ac";
				var modalInstance = $iqmodal.open({
							backdrop : "static",
							windowClass : 'mymodal confirm-modal modal',
							templateUrl : 'templates/common/iq_popupconfirm.html',
							resolve : {
								options : function() {
									return options;
								},
								m : {

				}
							},
							controller : function($scope, $modalInstance,
									options) {
								$scope.options = angular.copy(options);
								$scope.ok = function() {
									$modalInstance.close('ok');
								};
								$scope.cancel = function() {
									$modalInstance.dismiss('cancel');
								};
								$scope.close = function() {
									$modalInstance.dismiss('close');
								};
							}
						});

				modalInstance.opened.then(function() {
							$timeout(function() {
										$(".modal.mymodal").on(
												"click mouseup mousedown",
												function($event) {
													$event.stopPropagation();
												})
									})
						})
				return modalInstance.result;
			},
			prompt : function(label, placeholder, okButtonText,
					cancelButtonText) {
				if (angular.isUndefined(label)) {
					return;
				}
				var options = {
					label : label,
					placeholder : placeholder,
					okButtonText : okButtonText || '确定',
					cancelButtonText : cancelButtonText || '取消'
				};
				var modalInstance = $iqmodal.open({
							backdrop : "static",
							windowClass : 'mymodal',
							templateUrl : $iq_server.client()
									+ 'templates/common/iq_popupprompt.html',
							resolve : {
								options : function() {
									return options;
								}
							},
							controller : function($scope, $modalInstance,
									options) {
								$scope.options = angular.copy(options);
								$scope.result = {
									value : null
								};
								$scope.ok = function() {
									$modalInstance.close($scope.result.value);
								};
								$scope.cancel = function() {
									$modalInstance.dismiss('cancel');
								};
								$scope.close = function() {
									$modalInstance.dismiss('close');
								};
							}
						});
				return modalInstance.result;
			},
			deptlist : function(selectdata, type, manualurl) {
				var options = {
					selectdata : angular.copy(selectdata),
					type : type,
					manualurl : manualurl || 'departments/status-filter:1/tree'
				};

				var modalInstance = $iqmodal.open({
					backdrop : "static",
					windowClass : 'modal fade mymodal select-modal tree-modal',
					templateUrl : $iq_server.client()
							+ 'templates/common/iq_popupdept.html',
					resolve : {
						options : function() {
							return options;
						}
					},
					controller : function($scope, $modalInstance,
							$iq_popup_loadone) {
						$scope.options = options;
						// 创建filter数据
						$scope.deptFilter = '';
						$scope.restoreData = {};
						// 是否显示未激活的部门
						$scope.deptflag = false;
						$scope.showdisdept = function() {
							this.deptflag = !this.deptflag;
						}
						// 判断单选时是否显示icheck
						$scope.multiple = true;
						if (options.type && options.type == 'single') {
							$scope.multiple = false;
						}
						// 获取部门树数据
						$scope.data = [];
						// 点击带入弹出框的list数据
						$scope.depts = [];
            //无搜索条件查询部门
						var popSelectDeptFun = function() {
							var func = {
								success : function(re) {
									if(re.data.data <= 300){
										$iq_popup_loadone.loadone(options.manualurl).then(
												function(re) {
													$scope.data = angular.copy(re);
													// 处理带入数据的选中状态
													relinkDeptTree($scope.data,$scope.restoreData);
													if ($scope.depts.length > 0) {
														for (var j = 0; j < $scope.depts.length; j++) {
															var dept = $scope.restoreData[$scope.depts[j].id];
															if(dept){
																dept.flag = 1;
																$scope.depts[j] = dept;
															}
														}
													}
													//展开所有第一级
													for(var i = 0;i<$scope.data.length;i++){
														$scope.data[i].isExpanded = true;
													}
												}, function() {
													return;
												})
									}else{
										$iq_popup_loadone
										.loadone('/departments-root/status-filter:1')
										.then(function(re) {
											$scope.data = angular.copy(re);
											// 处理带入数据的选中状态
											relinkDeptTree($scope.data,$scope.restoreData);
											if ($scope.depts.length > 0) {
												for (var j = 0; j < $scope.depts.length; j++) {
													var dept = $scope.restoreData[$scope.depts[j].id];
													if(dept){
														dept.flag = 1;
														$scope.depts[j] = dept;
													}
												}
											}
										}, function() {
											return;
										})
									}
								}
							}
							var params = {
								method : "GET",
								url : $iq_server.server() + "departments/count"
							}
							$iq_http.http(params, func);
						}
						// 在查询部门之前先请求判断部门数量，若数量过大则不显示所有，而手动查询
						popSelectDeptFun();
						// 点击带入弹出框的list数据
						$scope.deptnodeclick = function(node) {
              if (node.flag == 1) {
								$scope.clearone(findIndex(node,$scope.depts));
							} else {
								if (options.type == 'single') {
									$scope.traverseTree($scope.data[0]);
									$scope.traverseTree($scope.depts);
									node.flag = 1;
									$scope.depts = [];
									$scope.depts.push(node);
								}else{
									node.flag = 1;
									$scope.depts.push(node);
								}
							}
						}
						//选部门组件,如果有子部门，且没有获取过子部门
						$scope.dept_expand_toggle = function(node) {
							if(node.sub && (!node.subDept || node.subDept.length<0)){
								$iq_popup_loadone.loadone('department/'+node.id+'/children/status-filter:1').then(function(re) {
										node.subDept = angular.copy(re);
										relinkDeptTree(node.subDept,$scope.restoreData);
										if ($scope.depts.length > 0) {
											for (var j = 0; j < $scope.depts.length; j++) {
												var dept = $scope.restoreData[$scope.depts[j].id];
												if(dept && dept!=$scope.depts[j]){
													dept.flag = 1;
													$scope.depts[j] = dept;
												}
											}
										}
									}, function() {
										return;
									})

							}
						}
						if (options.selectdata
								&& options.selectdata.constructor == Object) {
							$scope.depts.push(options.selectdata);
						} else if (options.selectdata) {
							$scope.depts = options.selectdata;
						}
						// 点击添加到depts （单选和多选）以及 选部门组件部门太多时一级一级获取
						$scope.nodeclick = function(node) {
							if (options.type == 'single') {
								$scope.depts.splice(0, 1, node);
							} else {
								if (node.flag == 0) {
									node.flag = 1;
									$scope.depts.push(node);
								} else if (node.flag == 1) {
									node.flag = 0;
									$scope.depts.splice(findIndex(node,$scope.depts), 1);
								}
							}
						}
						// 点击ichech添加到depts数组（多选）
						$scope.icheck = function(val) {
							if (val.flag == 0) {
								$scope.depts.splice(findIndex(val, $scope.depts), 1);
							} else if (val.flag == 1) {
								if(options.type == 'single'){
									$scope.traverseTree($scope.data[0]);
									$scope.traverseTree($scope.depts);
									val.flag = 1;
									$scope.depts = [];
									$scope.depts.push(val);
								}else{
									val.flag = 1;
									$scope.depts.push(val);
								}
							}
						}

						$scope.traverseTree = function (node){
					    if (!node) {
					        return;
					    }
							node.flag = 0;
					    if (node.subDept && node.subDept.length > 0) {
				        var i = 0;
				        for (i = 0; i < node.subDept.length; i++) {
			            $scope.traverseTree(node.subDept[i]);
				        }
					    }
						}

						// 清除单个
						$scope.clearone = function($index) {
							$scope.depts[$index].flag = 0;
							$scope.depts.splice($index, 1);
						}

						// 点击确定和取消
						$scope.ok = function() {
							delFlag($scope.depts);
							$modalInstance.close($scope.depts);
						}
						$scope.cancel = function() {
							$modalInstance.dismiss('cancel');
						};
						$scope.close = function() {
							$modalInstance.dismiss('close');
						};
            // 部门搜索
						$scope.deptSelect = function(deptname){
							$scope.data = [];
							if(deptname.length >0){
								var func = {
									success : function(re) {
										if(re.data.data.content.length > 0){
											$scope.data = re.data.data.content;
											relinkDeptTree($scope.data,$scope.restoreData);
											if ($scope.depts.length > 0) {
												for (var j = 0; j < $scope.depts.length; j++) {
													var dept = $scope.restoreData[$scope.depts[j].id];
													if(dept){
														dept.flag = 1;
														$scope.depts[j] = dept;
													}
												}
											}
										}
										if(re.data.data.content.length == 0){
											$scope.data = [];
										}
									},
									error: function(e) {
										console.log(e);
									}
								}
								var params = {
									method : "GET",
									url : $iq_server.server() + "/departments?search_LIKE_name="+deptname+"&pageSize=40&pageNo=1&childNum=true"
								}
								$iq_http.http(params, func);
							}else if(deptname.length == 0){
								$scope.data = [];
								popSelectDeptFun();
							}
						}
					}
				})
				return modalInstance.result;
			},
			deptpeople : function(selectdata, type) {
				var options = {
					selectdata : angular.copy(selectdata),
					type : type
				}
				var modalInstance = $iqmodal.open({
					backdrop : "static",
					windowClass : 'modal mymodal select-modal',
					templateUrl : $iq_server.client()
							+ 'templates/common/iq_popupdeptpeople.html',
					resolve : {
						options : function() {
							return options;
						}
					},
					controller : function($scope, $modalInstance,$timeout,
							$iq_popup_loadone) {
						$scope.options = options;
						// 创建filter数据
						$scope.peopleFilter = '';
						// 点击带入弹出框list数据
						$scope.peopledatalist = []
						$scope.personRestore = {};
						// 处理带入数据的单选和多选的情况
						if (options.selectdata
								&& options.selectdata.constructor == Object) {
							$scope.peopledatalist.push(options.selectdata);
						} else if (options.selectdata) {
							$scope.peopledatalist = options.selectdata;
						}
						// 判断单选时是否显示icheck
						$scope.multiple = true;
						if (options.type && options.type == 'single') {
							$scope.multiple = false;
						}
						// 获取部门数据
						$scope.data = [];
            // 获取人员数据
						$scope.lists = [];
						$scope.isShowPerson = false;
						$scope.isCollData = false;
						var popSelectPersonFun = function() {
							var func = {
								success : function(re) {
									if(re.data.data <= 1500){
										$scope.isShowPerson = false;
										$scope.isCollData = false;
										$iq_popup_loadone.loadone('departments/status-filter:1/tree').then(function(re) {
												$scope.data = angular.copy(re);
											}, function() {
												return;
											})
										$iq_popup_loadone.loadone('persons/all-active').then(function(re) {
													$scope.lists = angular.copy(re);
													relinkPerson($scope.lists,$scope.personRestore);
													// 处理带入数据的选中状态
													if ($scope.peopledatalist.length > 0) {
															for (var j = 0; j < $scope.peopledatalist.length; j++) {
																var peop = $scope.personRestore[$scope.peopledatalist[j].id];
																if(peop){
																	peop.flag = 1;
																	$scope.peopledatalist[j] = peop;
																}
															}
														}
												}, function() {
													return;
												})
									}else{
										$scope.isShowPerson = true;
									}
								}
							}
							var params = {
								method : "GET",
								url : $iq_server.server() + "persons/count"
							}
							$iq_http.http(params, func);
						}
						popSelectPersonFun();
						// 点击折叠或展开列表
						$scope.toggle1 = true;
						$scope.toggle2 = false;
						if ($scope.open) {
							$scope.toggle2 = $scope.open;
						}
						$scope.toggleclick = function(e) {
							this.toggle1 = !this.toggle1;
							this.toggle2 = !this.toggle2;
							if (e.stopPropagation) {
								e.stopPropagation(); // 标准浏览器的
							} else {
								e.cancelBubble = true; // IE浏览器
							}
						}
						// 点击折叠或展开未激活部门
						$scope.nodestatus = function(node) {
							if (node.status == 0) {
								return false;
							} else if (node.status == 1) {
								return true;
							}
						}
						$scope.peopleclick = function(node) {
							if (options.type == 'single') {
								$scope.peopledatalist.splice(0, 1, node);
							} else {
								if (node.flag == 1) {
									$scope.clearone(findIndex(node,$scope.peopledatalist));
								} else {
									node.flag = 1;
									$scope.peopledatalist.push(node);
								}
							}
						}
						// 点击ichech添加到peopledatalist数组（多选）
						$scope.icheck = function(val) {
							if (val.flag == 0) {
								$scope.clearone(findIndex(val,$scope.peopledatalist));
							} else if (val.flag == 1) {
								$scope.peopledatalist.push(val);
							}
						}
						$scope.selectPerson = function(person){
							if(person){
								$scope.data = [];
								$scope.lists = [];
								$scope.isShowPerson = false;
								var personSelect = function(person){
									var fun = {
											success : function(re) {
												if(person != $scope.peopleFilter){
													return;
												}
												if(re.data.data.content.length > 0){
													$scope.isCollData = false;
													$scope.data = re.data.data.content;
													$scope.lists = re.data.data.content;
													relinkPerson($scope.lists,$scope.personRestore);
													if ($scope.peopledatalist.length > 0) {
														for (var j = 0; j < $scope.peopledatalist.length; j++) {
															var peop = $scope.personRestore[$scope.peopledatalist[j].id];
															if(peop){
																peop.flag = 1;
																$scope.peopledatalist[j] = peop;
															}
														}
													}
												}
												if(re.data.data.content.length == 0){
													$scope.data = [];
													$scope.lists = [];
													$scope.isShowPerson = false;
													$scope.isCollData = true;
												}
											},
											error: function(e) {
												console.log(e);
											}
									}
									var params = {
										method : "GET",
										url : $iq_server.server() + "persons?search_EQ_status_0=1&pageSize=40&sort=ASC_pinyin&up_executive=1&search_Like_name_1="+ person +"&search_Like_itcode_2="+ person +"&formula=0 AND ( 1 OR  2)"
									}
									$iq_http.http(params, fun);
								}
								personSelect(person);
							}else{
								$scope.data = [];
								$scope.lists = [];
								popSelectPersonFun();
							}
						}

						// 清楚所有和清除单个
						$scope.clearone = function($index) {
							$scope.peopledatalist[$index].flag = 0;
							$scope.peopledatalist.splice($index, 1);
						}
						$scope.clearall = function() {
							delFlag($scope.peopledatalist)
							$scope.peopledatalist = [];
						}

						// 点击确定和点击取消
						$scope.ok = function() {
							delFlag($scope.peopledatalist);
							$modalInstance.close($scope.peopledatalist);
						}
						$scope.cancel = function() {
							$modalInstance.dismiss('cancel');
						}
						$scope.close = function() {
							$modalInstance.dismiss('close');
						};

					}
				})
				return modalInstance.result;
			},
			sharefile : function(selectdata, showtab) {
				var options = {
					selectdata : angular.copy(selectdata),
					showtab : showtab
				}
				var modalInstance = $iqmodal.open({
					backdrop : "static",
					windowClass : 'modal mymodal select-modal',
					templateUrl : $iq_server.client()
							+ 'templates/common/iq_popupsharefile.html',
					resolve : {
						options : function() {
							return options;
						}
					},
					controller : function($scope, $modalInstance,$timeout,options,
							$iq_popup_loadone) {
						$scope.options = options;
						// 创建filter数据
						$scope.allFilter = '';
						// 新建回调数组
						$scope.datalist = [];
						if (options.selectdata) { // 如果传入了list
							$scope.datalist = options.selectdata;
						}
						// 点击切换tab初始化
						$scope.tab1 = true;
						// 获取部门数据
						$scope.data = [];
            // 动态获取人员数据
						$scope.peopledata = [];
						$scope.personRestore = {};
						//数据量大时不显示数据
						$scope.isShowPerson = false;
						$scope.isHasData = false;
						//数据量大时不显示数据
						$scope.isShowDept = false;
						// 选人时，判断人数是否超过1500
						var popSelectPersonFun = function() {
							var func = {
								success : function(re) {
									if(re.data.data <= 1500){
										$scope.isHasData = false;
										$scope.isShowPerson = false;
										$iq_popup_loadone
												.loadone('departments/status-filter:1/tree')
												.then(function(re) {
															$scope.data = angular.copy(re);
														}, function() {
															return;
														})
										$iq_popup_loadone
												.loadone('persons/all-active?up_executive=1')
												.then(function(re) {
													$scope.peopledata = angular.copy(re);
													relinkPerson($scope.peopledata,$scope.personRestore);
													// 处理带入数据的选中状态
													if ($scope.datalist.length > 0) {
															for (var j = 0; j < $scope.datalist.length; j++) {
																var peop = $scope.personRestore[$scope.datalist[j].id];
																if(peop){
																	peop.flag = 1;
																	$scope.datalist[j] = peop;
																}
															}
														}
												}, function() {
													return;
												})
									}else{
										$scope.isShowPerson = true;
									}
								}
							}
							var params = {
								method : "GET",
								url : $iq_server.server() + "persons/count"
							}
							$iq_http.http(params, func);
						}
						popSelectPersonFun();
            // 创建过滤所有节点的数组
            $scope.checkdata = [];

						$scope.restoreData = {};
            // 获取部门数据
            $scope.deptdata = [];
						//无搜索条件查询部门
						var popSelectDeptFun = function() {
							// 部门数是否超过300
							var func = {
								success : function(re) {
									$scope.deptMore = re.data.data;
									if(re.data.data <= 300){
										// isOpen：根据部门数量的大小判断是否展开折叠
										$scope.isOpen = true;
										$scope.isShowDept = false;
										$iq_popup_loadone
												.loadone('departments/status-filter:1/tree')
												.then(function(re) {
													$scope.deptdata = angular.copy(re);
													relinkDeptTree($scope.deptdata,$scope.restoreData);
													if ($scope.datalist.length > 0) {
														for (var j = 0; j < $scope.datalist.length; j++) {
															var dept = $scope.restoreData[$scope.datalist[j].id];
															if(dept){
																dept.flag = 1;
																$scope.datalist[j] = dept;
															}
														}
													}
													//展开所有第一级
													for(var i = 0;i<$scope.deptdata.length;i++){
														$scope.deptdata[i].isExpanded = true;
													}
												}, function() {
													return;
												})
									}else{
										$scope.isOpen = false;
										$iq_popup_loadone
										.loadone('departments-root/status-filter:1')
										.then(function(re) {
											$scope.deptdata = angular.copy(re);
											relinkDeptTree($scope.deptdata,$scope.restoreData);
											if ($scope.datalist.length > 0) {
												for (var j = 0; j < $scope.datalist.length; j++) {
													var dept = $scope.restoreData[$scope.datalist[j].id];
													if(dept){
														dept.flag = 1;
														$scope.datalist[j] = dept;
													}
												}
											}
										}, function() {
											return;
										})
									}
								}
							}
							var params = {
								method : "GET",
								url : $iq_server.server() + "departments/count"
							}
							$iq_http.http(params, func);
						}

						// 点击添加到datalist数组
						$scope.deptnodeclick = function(node) {
							if (node.flag == 1) {
								$scope.clearone(findIndex(node,$scope.datalist));
							} else {
								node.flag = 1;
								$scope.datalist.push(node);
							}
						}
						//选部门组件,如果有子部门，且没有获取过子部门
						$scope.dept_expand_toggle = function(node) {
							if(node.sub && (!node.subDept || node.subDept.length<0)){
								$iq_popup_loadone.loadone('department/'+node.id+'/children/status-filter:1').then(function(re) {
										node.subDept = angular.copy(re);

										relinkDeptTree(node.subDept,$scope.restoreData);
										if ($scope.datalist.length > 0) {
											for (var j = 0; j < $scope.datalist.length; j++) {
												var dept = $scope.restoreData[$scope.datalist[j].id];
												if(dept && dept!=$scope.datalist[j]){
													dept.flag = 1;
													$scope.datalist[j] = dept;
												}
											}
										}
									}, function() {
										return;
									})

							}
						}
						// 点击折叠或展开列表
						$scope.toggle1 = true;
						$scope.toggle2 = false;
						if ($scope.open) {
							$scope.toggle2 = $scope.open;
						}
						$scope.toggleclick = function(e) {
							this.toggle1 = !this.toggle1;
							this.toggle2 = !this.toggle2;
							if (e.stopPropagation) {
								e.stopPropagation(); // 标准浏览器的
							} else {
								e.cancelBubble = true; // IE浏览器
							}
						}
						// 点击折叠或展开未激活部门
						$scope.nodestatus = function(node) {
							if (node.status == 0) {
								return false;
							} else if (node.status == 1) {
								return true;
							}
						}
						// 点击添加到datalist数组
						$scope.peopleclick = function(node) {
							if (node.flag == 1) {
								$scope.clearone(findIndex(node,$scope.datalist));
							} else {
								node.flag = 1;
								$scope.datalist.push(node);
							}
						}
						// 点击ichech添加到datalist数组
						$scope.icheck = function(val) {
							if (val.flag == 0) {
								$scope.clearone(findIndex(val,$scope.datalist));
							} else if (val.flag == 1) {
								$scope.datalist.push(val);
							}
						}
						// 点击切换tab事件
						$scope.tabchange = function(tab) {
							if (tab == 1) {
								$scope.tab1 = true;
								$scope.allFilter = ''; // 清空搜索项
								$scope.isHasData = false;
                popSelectPersonFun();
							} else {
								$scope.tab1 = false;
							};
							if (tab == 2) {
								$scope.tab2 = true;
								$scope.allFilter = ''; // 清空搜索项
								$scope.isHasData = false;
                //数据量大时不显示数据
								$scope.isShowDept = false;
								// 在查询部门之前先请求判断部门数量，若数量过大则不显示所有，而手动查询
								popSelectDeptFun();
							} else {
								$scope.tab2 = false;
							}
							if (tab == 3) {
								$scope.tab3 = true;
								$scope.allFilter = ''; // 清空搜索项
								// 创建过滤所有节点的数组
								$scope.checkdata = [];
								// 获取群组数据
								$scope.teamdata = [];
								$iq_popup_loadone
										.loadone('groups?page=1&pageSize=99999999')
										.then(function(re) {
											$scope.teamdata = angular.copy(re);
											// 处理带入数据的选中状态
											if ($scope.datalist.length > 0) {
												for (var i = 0; i < $scope.teamdata.length; i++) {
													var nodeobj = $scope.teamdata[i];
													for (var j = 0; j < $scope.datalist.length; j++) {
														var withobj = $scope.datalist[j];
														if (withobj.id == nodeobj.id) {
															nodeobj.flag = 1;
														}
													}
												}
											}
										}, function() {
											return;
										})
								// 点击添加到datalist数组
								$scope.teamnodeclick = function(node) {
									if (node.flag == 1) {
										$scope.clearone(findIndex(node,$scope.datalist)); // 标记位
									} else {
										node.flag = 1;
										$scope.datalist.push(node);
									}
								};
							} else {
								$scope.tab3 = false;
							}
							if (tab == 4) {
								// 切换到文件选项
								$scope.tab4 = true;
								$scope.allFilter = ''; // 清空搜索项
								// 创建过滤所有节点的数组
								$scope.checkdata = [];
								// 获取文件数据
								$scope.filedata = []
								$iq_popup_loadone
										.loadone('netdisk/common/dirstree?type=all')
										.then(function(re) {
											$scope.filedata = angular.copy(re);
											getallfilenode($scope.filedata,
													$scope.checkdata);
											// 处理带入数据的选中状态
											if ($scope.datalist.length > 0) {
												for (var i = 0; i < $scope.checkdata.length; i++) {
													var nodeobj = $scope.checkdata[i];
													for (var j = 0; j < $scope.datalist.length; j++) {
														var withobj = $scope.datalist[j];
														if (withobj.id == nodeobj.id) {
															nodeobj.flag = 1;
														}
													}
												}
											}
										}, function() {
											return;
										})
								// 点击添加到datalist数组
								$scope.filenodeclick = function(node) {
									if (node.id == "deny") {
										return;
									} else {
										if (node.flag == 1) {
											$scope.clearone(findIndex(node,
													$scope.datalist));
										} else {
											node.flag = 1;
											$scope.datalist.push(node);
										}
									}
								}
								// 点击ichech添加到datalist数组
								$scope.icheckfile = function(val) {
									if (val.flag == 0) {
										$scope.clearone(findIndex(val,
												$scope.datalist));
									} else if (val.flag == 1) {
										$scope.datalist.push(val);
									}
								}
							} else {
								$scope.tab4 = false;
							}
						}
            // 选人搜索
						$scope.selectPerson = function(person){
							if(person){
								$scope.data = [];
								$scope.peopledata = [];
								$scope.isShowPerson = false;
								var personSelect = function(person){
									var fun = {
											success : function(re) {
												if(person != $scope.allFilter){
													return;
												}
												if(re.data.data.content.length > 0){
													$scope.isHasData = false;
													$scope.peopledata = re.data.data.content;
													relinkPerson($scope.peopledata,$scope.personRestore);
													if ($scope.datalist.length > 0) {
														for (var j = 0; j < $scope.datalist.length; j++) {
															var peop = $scope.personRestore[$scope.datalist[j].id];
															if(peop){
																peop.flag = 1;
																$scope.datalist[j] = peop;
															}
														}
													}
												}
												if(re.data.data.content.length == 0){
													$scope.peopledata = [];
													$scope.data = [];
													$scope.isShowPerson = false;
													$scope.isHasData = true;
												}
											},
											error: function(e) {
												console.log(e);
											}
									}
									var params = {
										method : "GET",
										url : $iq_server.server() + "persons?search_EQ_status_0=1&pageSize=40&sort=ASC_pinyin&up_executive=1&search_Like_name_1="+ person +"&search_Like_itcode_2="+ person +"&formula=0 AND ( 1 OR  2)"
									}
									$iq_http.http(params, fun);
								}
								personSelect(person);
							}else{
								$scope.data = [];
								$scope.peopledata = [];
								popSelectPersonFun();
							}
						}
						// 清除单个
						$scope.clearone = function($index) {
							$scope.datalist[$index].flag = 0;
							$scope.datalist.splice($index, 1);
						}
						// 清除全部
						$scope.clearall = function() {
							addFlag0($scope.datalist)
							$scope.datalist = [];
						}
						// 显示文件选项卡
						$scope.team = false;
						$scope.file = false;
						if (options.showtab) {
							if (options.showtab == 'team') {
								$scope.team = true;
							}
							if (options.showtab == 'file') {
								$scope.file = true;
							}
						}
						// 点击确定和点击取消
						$scope.ok = function() {
							// 去掉flag属性
							delFlag($scope.datalist)
							// 去掉部门obj中的子部门
							if ($scope.datalist.length > 0) {
								for (var i = 0; i < $scope.datalist; i++) {
									var cur = $scope.datalist[i];
									if (cur.subDept && cur.subDept.length > 0) {
										cur.subDept = [];
									}
								}
							}
							$modalInstance.close($scope.datalist);
						}
						$scope.cancel = function() {
							$modalInstance.dismiss('cancel');
						}
						$scope.close = function() {
							$modalInstance.dismiss('close');
						};
            // 部门搜索
						$scope.deptSelect = function(deptname){
							$scope.deptdata = [];
							$scope.checkdata = [];
							$scope.data = [];
							$scope.isShowDept = false;
							if(deptname.length >0){
								var func = {
									success : function(re) {
										if(re.data.data.content.length > 0){
											$scope.deptdata = re.data.data.content;
											$scope.isHasData = false;

											relinkDeptTree($scope.deptdata,$scope.restoreData);
											if ($scope.datalist.length > 0) {
												for (var j = 0; j < $scope.datalist.length; j++) {
													var dept = $scope.restoreData[$scope.datalist[j].id];
													if(dept){
														dept.flag = 1;
														$scope.datalist[j] = dept;
													}
												}
											}
										}
										if(re.data.data.content.length == 0){
											$scope.deptdata = [];
											$scope.isHasData = true;
										}
									},
									error: function(e) {
										console.log(e);
									}
								}
								var params = {
									method : "GET",
									url : $iq_server.server() + "/departments?search_LIKE_name="+deptname+"&pageSize=40&pageNo=1&childNum=true"
								}
								$iq_http.http(params, func);

							}else if(deptname.length == 0){
								$scope.deptdata = [];
								popSelectDeptFun();
							}
						}
					}
				})
				return modalInstance.result;
			},
			filetree : function(filePath, fileName) {
				var options = {
					filePath : filePath,
					fileName : fileName
				};
				var modalInstance = $iqmodal.open({
					// backdrop : "static",
					windowClass : 'modal mymodal select-modal tree-modal',
					templateUrl : 'templates/common/iq_file_tree.html',
					resolve : {
						options : function() {
							return options;
						}
					},
					controller : function($scope, $modalInstance, options,
							$iq_popup_loadone) {
						// 初始过滤条件为空
						$scope.fileFilter = '';
						$scope.options = angular.copy(options);
						// 显示选中样式
						$scope.id = null;
						$scope.active = function(b) {
							$scope.id = b.id;
						}
						// 点击折叠或展开列表
						$scope.toggle1 = true;
						$scope.toggle2 = false;
						if ($scope.open) {
							$scope.toggle2 = $scope.open;
						}
						$scope.toggleclick = function(e) {
							this.toggle1 = !this.toggle1;
							this.toggle2 = !this.toggle2;
							if (e.stopPropagation) {
								e.stopPropagation(); // 标准浏览器的
							} else {
								e.cancelBubble = true; // IE浏览器
							}
						}
						// 获取后台文件库数据
						$scope.data = [];
						$iq_popup_loadone.loadone('netdisk/common/dirstree?type=PSN')
								.then(function(re) {
									$scope.data = (angular.copy(re) == null
											? []
											: angular.copy(re));
									// $scope.data.push({
									// id:"root",
									// name:"我的文件库",
									// subDirs:$scope.child
									// });
									// 返回数据节点放入过滤数据中
									$scope.filterList = [];
									getallfilenode($scope.data,
											$scope.filterList);
								}, function() {
									$scope.data = [];
								})
						// 创建点击接收数据的数组
						$scope.dataList = {};
						// 点击添加到dataList （单选）
						$scope.singleclick = function(node) {
							$scope.dataList = node;
						}
						// 点击确定 、取消和关闭
						$scope.ok = function() {
							if (options.filePath && options.fileName
									&& $scope.dataList.id) {
								var param = {
									"dirId" : $scope.dataList.id,
									"filePath" : options.filePath,
									"fileName" : options.fileName
								}
								var saveNetdisk = $iq_http.http({
									method : 'POST',
									url : $iq_server.server()
											+ 'netdisk/person/synfiletomylibrary',
									data : param
								});
								saveNetdisk.then(function(re) {
											if (re.data.success) {
												my_alert("同步成功！", "1",
														"success");
											} else if (!re.data.success) {
												my_alert("同步失败！", "1", "fail");
											}
											$modalInstance.close(re);
										}, function() {
											my_alert("同步失败！", "1", "fail");
											$modalInstance.close('fail');
										});
							} else {
								my_alert("请选择一个文件夹！", "1", "warn");
							}

						};
						$scope.cancel = function() {
							$modalInstance.dismiss('cancel');
						}
						$scope.close = function() {
							$modalInstance.dismiss('close');
						};
					}
				});
				return modalInstance.result;
			},
			role : role_popup
		}
	}

	var $iq_popup_loadone = function($iq_http, $q, $iq_server) {
		var limitTime = 1 * 60 * 1000; // 保留1分钟
		var datacontainer = {};
		var loadone = function(_param) {
			if (_param && angular.isString(_param)) {
				var _p = datacontainer[_param]; // perimission对象
				if (_p) {
					if (_p.promise) { // 在请求时间内，返回请求的promise
						return _p.promise;
					} else if (datacontainer[_param].timeStamp > new Date()
							- limitTime) { // 在缓存时间内，直接返回
						var def = $q.defer();
						def.resolve(datacontainer[_param].value);
						return def.promise;
					}
				}
				// 没有有效的permission，请求后台
				var def = $q.defer();
				$iq_http.http({
							method : "GET",
							//params:{type:'PSN'},
							url : $iq_server.server() + _param
						}).then(function(result) {
							var v = result.data.list || (result.data.data && result.data.data.content || result.data.data);
							datacontainer[_param] = {
								value : v,
								timeStamp : new Date()
							};
							def.resolve(v);
						}, function() {
							def.reject();
						})
				datacontainer[_param] = {
					"promise" : def.promise
				};
				return datacontainer[_param].promise;
			} else {
				dataparam = angular.copy(_param);
				if (dataparam.time) {
					$iq_http.http({
						method : 'GET',
						url : $iq_server.server()
								+ 'departments/status-filter:1/tree'
					}).then(function(re) {
						var result = re.data.data && re.data.data.content || re.data.data;
						datacontainer['departments/status-filter:1/tree'] = result;
					}, function(e) {
						console.log(e);
					})

					$iq_http.http({
						method : 'GET',
						url : $iq_server.server()
								+ 'persons/all-active?up_executive=1'
					}).then(function(re) {
						var result = re.data.data && re.data.data.content || re.data.data;
						datacontainer['persons/all-active?up_executive=1'] = result;
					}, function(e) {
						console.log(e);
					})
				}
				return datacontainer.promise;
			}
		}
		return {
			loadone : loadone
		}
	}

	var $notice_service = function($iq_http, $iq_server, $iq_popup, $iq_loading) {

		var save = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						$iq_loading.hide();// 隐藏加载
						if (re.data.success == true) {
							$iq_popup.alert("发送成功！", 3, "success");
						} else {
							$iq_popup.alert(re.data.message, 3, "fail");
						}
						success(re);
					}
				}
			}
			var params = {
				data : param,
				dataType : "json",
				method : "POST",
				url : $iq_server.server() + "notice/data"
			}
			$iq_http.http(params, func);
		}

		return {
			save : save
		}
	}

	var $store_service = function($iq_http, $iq_server, $iq_popup, $iq_loading) {

		var save = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						$iq_loading.hide();// 隐藏加载
						if (re.data.success == true) {
							$iq_popup.alert("收藏成功！", 3, "success");
						} else {
							$iq_popup.alert(re.data.message, 3, "fail");
						}
						success(re);
					}
				}
			}
			var params = {
				data : param,
				dataType : "json",
				method : "POST",
				url : $iq_server.server() + "store/data"
			}
			$iq_http.http(params, func);
		}

		var del = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						$iq_loading.hide();// 隐藏加载
						if (re.data.success == true) {
							$iq_popup.alert("取消收藏成功！", 3, "success");
						} else {
							$iq_popup.alert(re.data.message, 3, "fail");
						}
						success(re);
					}
				}
			}
			var params = {
				// data: param,
				method : "DELETE",
				url : $iq_server.server() + "store/data/blog/" + param.objId
			}
			$iq_http.http(params, func);
		}

		var find = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				// params: param,
				method : "GET",
				url : $iq_server.server() + "/store/data/" + param.newsId
			}
			$iq_http.http(params, func);
		}

		return {
			save : save,
			del : del,
			find : find
		}
	}

	var $iqa_task_common_service = function($iq_http, $iq_server) {
		// 默认参数传null，查询我的任务，查询他人与我共同的任务则传{userId:'1234'}
		var findTopFive = function(success, _param) {
			var func = {
				success : function(re) {
					if (success && re.data.success) {
						success(re.data.data);
					} else {
					}
				}
			}
			var param = {
				'sortInfo' : 'ASC_endDate',
				pageNo : '1',
				pageSize : '5'
			}; // 默认查询我的任务
			if (_param) {
				angular.forEach(_param, function(v, k) {
							param.k = v;
						});
			}
			var param = {
				params : param,
				method : "GET",
				url : $iq_server.server() + "task/tasks/top-five"
			}
			$iq_http.http(param, func);
		}

		return {
			findTopFive : findTopFive
		}
	}

	var $attention_service = function($iq_http, $iq_server, $iq_popup,
			$iq_loading) {

		var save = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						$iq_loading.hide();// 隐藏加载
						if (re.data.success == true) {
							$iq_popup.alert("关注成功！", 3, "success");
						} else {
							$iq_popup.alert(re.data.message, 3, "fail");
						}
						success(re);
					}
				}
			}
			var params = {
				data : param,
				dataType : "json",
				method : "POST",
				url : $iq_server.server() + "blogattention/data"
			}
			$iq_http.http(params, func);
		}

		var del = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						$iq_loading.hide();// 隐藏加载
						if (re.data.success == true) {
							$iq_popup.alert("取消关注成功！", 3, "success");
						} else {
							$iq_popup.alert(re.data.message, 3, "fail");
						}
						success(re);
					}
				}
			}
			var params = {
				// data: param,
				method : "DELETE",
				url : $iq_server.server() + "blogattention/data/" + param.objId
			}
			$iq_http.http(params, func);
		}

		var find = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				// params: param,
				method : "GET",
				url : $iq_server.server() + "blogattention/data/" + param.type
						+ "/" + param.objId
			}
			$iq_http.http(params, func);
		}

		var findfans = function(success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				method : "GET",
				url : $iq_server.server() + "blogattention/data/fans"
			}
			$iq_http.http(params, func);
		}

		var findattentions = function(success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				method : "GET",
				url : $iq_server.server() + "blogattention/datas"
			}
			$iq_http.http(params, func);
		}

		var findfansById = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				// params: param,
				method : "GET",
				url : $iq_server.server() + "blogattention/data/fans/"
						+ param.id
			}
			$iq_http.http(params, func);
		}

		var findattentionsById = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				// params: param,
				method : "GET",
				url : $iq_server.server() + "blogattention/data/attention/"
						+ param.id
			}
			$iq_http.http(params, func);
		}

		var findoneattention = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				// params: param,
				method : "GET",
				url : $iq_server.server()
						+ "blogattention/data/attention/user/" + param.userId
			}
			$iq_http.http(params, func);
		}

		return {
			save : save,
			del : del,
			find : find,
			findfans : findfans,
			findattentions : findattentions,
			findfansById : findfansById,
			findattentionsById : findattentionsById,
			findoneattention : findoneattention
		}
	}

	var $discuss_service = function($iq_http, $iq_server, $iq_popup) {

		var del = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						if (re.data.success == true) {
							$iq_popup.alert("删除评论成功！", 3, "success");
						} else {
							$iq_popup.alert(re.data.message, 3, "fail");
						}
						success(re);
					}
				}
			}
			var params = {
				// data: param,
				method : "DELETE",
				url : $iq_server.server() + "discuss/data/" + param.masterId
						+ "/" + param.discussId + "/" + param.discussType
			}
			$iq_http.http(params, func);
		}

		var getCount = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				// params: param,
				method : "GET",
				url : $iq_server.server() + "discusslist/data/count/"
						+ param.masterId
			}
			$iq_http.http(params, func);
		}

		return {
			del : del,
			getCount : getCount
		}
	}

	var $blog_service = function($iq_http, $iq_server, $iq_popup) {

		var save = function(datas, success) {
			var blogParam = datas;
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				data : blogParam,
				method : "POST",
				url : $iq_server.server() + "microblog/data/blog",
				dataType : "json"
			}
			$iq_http.http(params, func);
		}

		var del = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				method : "DELETE",
				url : $iq_server.server() + "blogall/data/blogs/" + param.id
			}
			$iq_http.http(params, func);
		}

		var findpersonel = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				params : param,
				method : "GET",
				url : $iq_server.server() + "blogall/data/personel"
			}
			$iq_http.http(params, func);
		}

		var getdep = function(success, userId, level) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				method : "GET",
				url : $iq_server.server() + "person/" + userId
						+ "/parent-and-child-departments/child-level:" + level
			}
			$iq_http.http(params, func);
		}

		return {
			del : del,
			save : save,
			findpersonel : findpersonel,
			getdep : getdep
		}
	}

	var $tag_service = function($iq_http, $iq_server, $iq_popup) {

		var findByObjId = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				// params: param,
				method : "GET",
				url : $iq_server.server() + "labelobject/data/" + param.objId
			}
			$iq_http.http(params, func);
		}

		return {
			findByObjId : findByObjId
			,
		}
	}

	var $iq_schedul_service = function($iq_http, $iq_server) {

		var list = function(date, success) {
			var params = {
				method : "GET",
				params : {
					"time" : date,
					"pageNo" : 1,
					"pageSize" : 5,
					"sortInfo" : "DESC_createDate"
				},
				url : $iq_server.server() + "schedul/top-five"
			}
			$iq_http.http(params).then(function(re) {
						if (success) {
							success(re);
						}
					}, function() {
						console.log("首页日程信息获取失败");
					});

		}

		/**
		 * 用于个人主页查询前5条数据 userId userId date yyyy-mm-dd
		 */
		var personalTop = function(userId, date, success) {
			var func = function(re) {
				if (re.data.success && success) {
					success(re);
				}
			}
			var params = {
				method : "GET",
				params : {
					schedulDate : date,
					userId : userId,
					page : 1,
					pageSize : 5
				},
				url : $iq_server.server() + "schedul/top"
			}
			$iq_http.http(params).then(func);
		}
		return {
			list : list,
			personalTop : personalTop
		};
	}

	// 商城轮播图service
	var $iq_istore_service = function($iq_http, $iq_server) {

		var list = ['theme/img/istore/istore.jpg', 'theme/img/istore/istore1.jpg',
				'theme/img/istore/istore2.jpg', 'theme/img/istore/istore3.jpg',
				'theme/img/istore/istore4.jpg', 'theme/img/istore/istore5.jpg',
				'theme/img/istore/istore6.jpg', 'theme/img/istore/istore7.jpg',
				'theme/img/istore/istore8.jpg'];
		return {
			list : list
		};
	}

	var $iq_pop_select = function($iq_server, $iqmodal, $iq_window, $q) {
		return {
			popsingleselect : function(p_obj) {
				// 将一个或多个对象的属性合并起来
				var obj = angular.extend({
							label : '选择弹出框...',
							okName : "保存",
							cancelName : "取消"
						}, p_obj);
				// 如果内容项目为空，则报出提示
				if (obj.items == null || obj.items.length == 0) {
					$iq_window.alert({
								message : "可选数据为空！",
								type : 'warn'
							});
					var def = $q.defer();
					def.reject("no data");
					return def.promise;
				}
				// 选项数组
				var itrm = [];
				for (var i = 0; i < obj.items.length; i++) {
					// Object.keys()返回一个数组，该数组内存放obj可被枚举的所有属性
					var arr = Object.keys(obj.items[i]);
					if (arr.indexOf('id') == -1 || arr.indexOf('name') == -1
							|| typeof obj.items[i].id != 'string'
							|| trim(obj.items[i].id) == ''
							|| typeof obj.items[i].name != 'string'
							|| trim(obj.items[i].name) == '') {
						$iq_window.alert({
									message : "系统错误，属性不满足条件！",
									type : 'warn'
								});
						var def = $q.defer();
						def.reject("no data");
						return def.promise;
					}
					// 返回数组列表
					itrm.push({
								id : obj.items[i].id,
								name : obj.items[i].name,
								check : false
							});
				}
				obj.items = itrm;
				// 如果只有一个选项，默认勾选
				if (obj.items.length == 1) {
					obj.items[0].check = true;
				} else {

					if (obj.choiceItem != null && obj.choiceItem.length != 0) {
						for (var j = 0; j < obj.items.length; j++) {
							if (obj.items[j].id == obj.choiceItem[0].id) {
								obj.items[j].check = true;
								break;
							}
						}
					}
				}
				var modalInstance = $iqmodal.open({
							backdrop : "static",
							windowClass : 'modal fade mymodal select-radio-modal',
							templateUrl : $iq_server.client()
									+ 'templates/common/pop_single_select.html',
							resolve : {
								options : function() {
									return obj;
								}
							},
							controller : function($scope, $modalInstance,
									options, $iq_popup) {
								$scope.options = angular.copy(options);
								var items = angular.copy($scope.options.items);
								var result = null;
								$scope.selectItem = function(item) {
									for (var i = 0; i < items.length; i++) {
										if (items[i].id == item.id) {
											items[i].check = true;
										} else {
											items[i].check = false;
										}
									}
								}

								if (items && items.length == 1) {
									$scope.abcd = 0;// (items[0]);
								}
								$scope.ok = function() {
									for (var i = 0; i < items.length; i++) {
										if (items[i].check) {
											delete items[i].check;
											result = items[i];
											break;
										}
									}
									if (result == null) {
										$iq_popup.alert('请选择一项!', 2, 'warn');
										return;
									}
									$modalInstance.close(result);
								};
								$scope.cancel = function() {
									$modalInstance.dismiss('cancel');
								};
								$scope.close = function() {
									$modalInstance.dismiss('close');
								};
							}
						});
				return modalInstance.result;
			},
			popmultipleselect : function(p_obj) {
				var obj = angular.extend({
							label : '选择弹出框...',
							okName : "保存",
							cancelName : "取消"
						}, p_obj);
				if (obj.items == null || obj.items.length == 0) {

					$iq_window.alert({
								message : "可选数据为空！",
								type : 'warn'
							});
					var def = $q.defer();
					def.reject("no data");
					return def.promise;

				}
				var itrm = [];
				for (var i = 0; i < obj.items.length; i++) {
					var arr = Object.keys(obj.items[i]);
					if (arr.indexOf('id') == -1 || arr.indexOf('name') == -1
							|| typeof obj.items[i].id != 'string'
							|| trim(obj.items[i].id) == ''
							|| typeof obj.items[i].name != 'string'
							|| trim(obj.items[i].name) == '') {
						$iq_window.alert({
									message : "系统错误，属性不满足条件！",
									type : 'warn'
								});
						var def = $q.defer();
						def.reject("no data");
						return def.promise;

					}
					itrm.push({
								id : obj.items[i].id,
								name : obj.items[i].name,
								check : false
							});
				}
				obj.items = itrm;
				if (obj.items.length == 1) {
					obj.items[0].check = true;
				} else {
					if (obj.choiceItem != null && obj.choiceItem.length != 0) {
						for (var i = 0; i < obj.choiceItem.length; i++) {
							for (var j = 0; j < obj.items.length; j++) {
								if (obj.items[j].id == obj.choiceItem[i].id) {
									obj.items[j].check = true;
									break;
								}
							}
						}
					}
				}
				var modalInstance = $iqmodal.open({
							backdrop : "static",
							windowClass : 'modal fade mymodal select-checkbox-modal',
							templateUrl : $iq_server.client()
									+ 'templates/common/pop_multiple_select.html',
							resolve : {
								options : function() {
									return obj;
								}
							},
							controller : function($scope, $modalInstance,
									options, $iq_popup) {
								$scope.options = angular.copy(options);
								var items = angular.copy($scope.options.items);
								var result = [];
								var tmp = [];
								for(var i=0; i<items.length; i++){
									if(items[i].check){
										tmp.push(i);
									}
								}
								$scope.selectItem = function(index) {
									items[index].check = !items[index].check;
									if(items[index].check){ //选
										tmp.push(index);
									}else{ //不选
										tmp.splice(tmp.indexOf(index),1);
									}
								}
								$scope.ok = function() {
									for(var i = 0; i < tmp.length; i++){
										result.push({'id': items[tmp[i]].id,'name': items[tmp[i]].name});
									}
									if (result.length == 0) {
										$iq_popup.alert('请至少选择一项!', 2, 'warn');
										return;
									}
									$modalInstance.close(result);
								};
								$scope.cancel = function() {
									$modalInstance.dismiss('cancel');
								};
								$scope.close = function() {
									$modalInstance.dismiss('close');
								};
							}
						});
				return modalInstance.result;
			}
		}
	}

	//excel上传
	var $iq_excel = function($iqmodal,$iq_server,$iq_popup,$iq_http){
		return {
			download_auth : function(moduleCode,form,org,callback){
				var func = {
					success : function(re) {
						if (callback && re.data.success) {
							if(re.data.message.validation == true){
								callback(true);
							}else{
								$iq_popup.alert(re.data.message.validation);
							}
						}
					}
				}
				var params = {
					method :'GET',
					url : $iq_server.server() + "excel/download/auth/"+moduleCode+"/"+form+"/"+org
				}
				$iq_http.http(params, func);
			},
			upload_progress : function(uploader,fileItem){
				var options = {
					uploader : uploader,
					fileItem : fileItem,
				};
				var modalInstance = $iqmodal.open({
					windowClass : 'modal fade mymodal upload-proinfo-modal in',
					templateUrl : './templates/common/excel_upload_progress.html',
					resolve : {
						options : function() {
							return options;
						}
					},
					controller : function($scope,$modalInstance){
						$scope.fileItem = fileItem;
						$scope.uploader = uploader;
						$scope.cancel = function() {
							$modalInstance.dismiss('cancel');
						};

						var progress = function(){
							if($scope.fileItem.progress == 100){
								$modalInstance.close(uploader);
							}
						}
						$scope.cancelUpload = function(){
							uploader.removeFromQueue(fileItem)
							$modalInstance.close(uploader);
						}
						$scope.$watch("fileItem.progress", progress);
					}
				})
				return modalInstance.result;
			},
			handle_excel : function(url,list,callback){
				var func = {
					success : function(re) {
						if (callback && re.data.success) {
							callback(re.data.data);
						}else{
							$iq_popup.alert(re.data.message);
						}
					}
				}
				var params = {
					data : list,
					method :'POST',
					url : url
				}

				$iq_http.http(params, func);
			},
			display_contents : function(list){
				var options = {
					list : list,
				};
				var modalInstance = $iqmodal.open({
					backdrop : "static",
					windowClass : 'modal fade mymodal check-proinfo-modal in',
					templateUrl : './templates/common/upload_excel_content.html',
					resolve : {
						options : function() {
							return options;
						}
					},
					controller : function($scope,$modalInstance,$iq_loading){
						//标志所有数据是否合法
						$scope.validation = true;
						//如果length为1表示只有excel表头信息
						if(list.length==1){
							$scope.empty = true;
						}else{
							$scope.empty = false;
						}
						$scope.header = list[0];
						$scope.list = list;
						var flag = false;
						if(!$scope.empty){
							//判断所有数据是否合法
							for(var i = 0;i<list.length;i++){
								for(var j =0;j<list[i].length;j++){
									var temp = list[i];
									flag = temp[j].validation;
									if(!flag){
										$scope.validation = false;
										break;
									}
								}
								if(!flag){
									break;
								}
							}
						}

						//保存数据
						$scope.save = function(){
							for(var i = 0;i<list.length;i++){
								for(var j=0;j<list[i].length;j++){
									var temp = list[i];
									delete temp[j].validation;
									delete temp[j].error;
								}
							}
							$modalInstance.close(list);
						}
						$scope.cancel = function() {
							$modalInstance.dismiss('cancel');
						};
					}
				})
				return modalInstance.result;
			},
		}
	}
	var faceService = function($iq_http, $iq_server, $iq_popup) {
		var names = [
		             '大笑','白眼','猪','微笑','害羞','可爱','色','飞吻','亲亲','1',
		             '1','调皮','吐舌头','1','发呆','龇牙','不屑','傲慢','鄙视','衰',
		             '难过','1','笑喷','流泪','折磨','冷汗','惊恐',

		             '流汗','尴尬','大哭','抓狂','1','害怕','1','愤怒','发怒','1',
		             '1','1','生病','得意','困','1','晕','委屈','1','1',
		             '坏笑','小恶魔','惊讶','1','闭嘴','撇嘴','1',

		             '1','1','酷','1','老板','1','1','1','1','1',
		             '跑腿小弟','跑堂小妹','1','1','1','1','1','天使','1','1',
		             '憨笑','1','1','阴险','吓','可怜','1',

		             '1','1','1','不要看','投降','偷笑','骷髅','外星人','屎','火焰',
		             '发光','星星','1','Bang！','1','雨水','1','睡觉','吹起','1',
		             '1','1','1','1','赞','真挫','1',

		             '拳头','1','耶','1','1','1','1','1','1','1',
		             '1','1','1','鼓掌','强','1','快跑','跳舞','男女','一家人',
		             '1','1','亲亲我我','1','兔女郎','OK','NO',

		             '1','举手','按摩','剪发','1','1','1','1','思考','1',
		             '王冠','1','1','1','1','1','1','1','1','1',
		             '1','1','1','1','比基尼','1','1',

		             '1','1','眼镜','礼物','雨伞','1','1','1','1','1',
		             '红心','心碎','1','1','心','1','1','丘比特','1','1',
		             '1','1','1','1','1','1','1',
		           ];
		var faces = [];
		for(var i=0;i<names.length;i++){
		      if (names[i] === '1') {
		        continue;
		      }else if(names[i]!="1"){
		        var x = i%27;
		        var y = parseInt(i/27);
		        var str = "face"+i;
		        var face = {
		        		title:names[i],
		        		faceclass:str
		        }
		        faces.push(face);
		      }
		    }
	    return {
	        getFaces: function() {
	            return faces;
	        }
	    }
	}
	var userInfo = function($iq_http,$iq_server){
		//获取人员基本信息
		var getOnePerson = function(id,callback){
			var func = {
				success:function(re){
					if(callback)
					{
						callback(re);
					}
				}
			}
			var params = {
				method:"GET",
				url:$iq_server.server() + "person/"+id,
				params:{"up_executive":1}
			}
			$iq_http.http(params,func);
		}
		return{
			getOnePerson:getOnePerson
		}
	}
	//文件库选人组件通用
	var iq_dialog =function($iq_http,$iq_server,$iqmodal){
		// 遍历数组添加属性Flag=0
		var addFlag0 = function(data) {
			for (var i = 0; i < data.length; i++) {
				data[i].flag = 0;
			}
		}
		// 遍历数组添加属性Flag=1
		var addFlag1 = function(data) {
			for (var i = 0; i < data.length; i++) {
				data[i].flag = 1;
			}
		}
		// 遍历数组删除属性
		var delFlag = function(data) {
			if(!data){
				return;
			}
			for (var i = 0; i < data.length; i++) {
				delete data[i].flag;
			}
		}
		// 递归深度遍历部门数组获得节点
		var getallnode = function(data, getdata) {
			if(!data){
				return;
			}
			for (var i = 0; i < data.length; i++) {
				var tempdata = data[i];
				getdata.push(tempdata);
				if (tempdata.subDept && tempdata.subDept.length > 0) {
					getallnode(tempdata.subDept, getdata);
				}
			}
		}
		// 递归深度遍历部门数组,将data中的数据存储到restore，同时将data的id相同数据匹配到restore中相同数据
		var relinkDeptTree = function(deptData, restore) {
			if(!deptData){
				return;
			}
			for (var i = 0; i < deptData.length; i++) {
				var restoreDept = restore[deptData[i].id];
				var recursionFlag = true;
				if(restoreDept){
					if(restoreDept.subDept && restoreDept.subDept.length>0){
						//存储的值有子部门
						recursionFlag = false;
					}else{
						//没有子部门，直接从deptData赋值
						restoreDept.subDept = deptData[i].subDept;
					}
					deptData[i] = restoreDept;//让deptData中的对象等于存储对象
				}else{
					restoreDept = restore[deptData[i].id] = deptData[i];
				}
				//如果子部门是新赋值的，递归子部门
				if (recursionFlag && restoreDept.subDept && restoreDept.subDept.length > 0) {
					relinkDeptTree(restoreDept.subDept, restore);
				}
			}
		}
		var relinkPerson = function(personData, restore) {
			if(!personData){
				return;
			}
			for (var i = 0; i < personData.length; i++) {
				var restorePerson = restore[personData[i].id];
				var recursionFlag = true;
				if(restorePerson){
					personData[i] = restorePerson;//让personData中的对象等于存储对象
				}else{
					restorePerson = restore[personData[i].id] = personData[i];
				}
			}
		}
		var getallfilenode = function(data, getdata) {
			if(!data){
				return;
			}
			for (var i = 0; i < data.length; i++) {
				var tempdata = data[i];
				getdata.push(tempdata);
				if (tempdata.subDirs && tempdata.subDirs.length > 0) {
					getallfilenode(tempdata.subDirs, getdata);
				}
			}
		}
		// 遍历找标记位
		var findIndex = function(node, data) {
			if(!data){
				return;
			}
			for (var i = 0; i < data.length; i++) {
				if (node.id == data[i].id) {
					return i;
				}
			}
		}
	 var sharefilePeople = function(selectdata, showtab){
		 var options = {
					selectdata : angular.copy(selectdata),
					showtab : showtab
				}
		 var modalInstance = $iqmodal.open({
			 	backdrop : "static",
				windowClass : 'modal mymodal select-modal select-new-modal selectPeoplePlate-modal',
				templateUrl : $iq_server.client()
						+ 'templates/common/iq_dialogsharefile_people.html',
				resolve : {
					options : function() {
						return options;
					}
				},
				controller : function($scope, $modalInstance,
						$iq_popup_loadone) {
					//共享弹出窗口模糊选择
					$scope.options = options;
					// 创建filter数据
					$scope.allFilter = '';
					$scope.datalist = [];
					$scope.peopledata = [];
					$iq_popup_loadone
							.loadone('persons/all-active?up_executive=1')
							.then(function(re) {
								$scope.peopledata = angular.copy(re);
							}, function() {
								return;
							});
					// 点击添加到datalist数组
					$scope.peopleclick = function(node) {
						if (node.flag == 1) {
							$scope.clearone(findIndex(node,$scope.datalist));
						} else {
							node.flag = 1;
							$scope.datalist.push(node);
						}
						$modalInstance.close($scope.datalist);
					}
					// 点击折叠或展开列表
					$scope.toggle1 = true;
					$scope.toggle2 = false;
					if ($scope.open) {
						$scope.toggle2 = $scope.open;
					}
					$scope.toggleclick = function(e) {
						this.toggle1 = !this.toggle1;
						this.toggle2 = !this.toggle2;
						if (e.stopPropagation) {
							e.stopPropagation(); // 标准浏览器的
						} else {
							e.cancelBubble = true; // IE浏览器
						}
					}
					// 点击折叠或展开未激活部门
					$scope.nodestatus = function(node) {
						if (node.status == 0) {
							return false;
						} else if (node.status == 1) {
							return true;
						}
					}
					$scope.close = function() {
						$modalInstance.dismiss('close');
					};
				}
		 })
		 return modalInstance.result;

	 }
	 var sharefile = function(selectdata, showtab){
		 var options = {
					selectdata : angular.copy(selectdata),
					showtab : showtab
				}
		 var modalInstance = $iqmodal.open({
				backdrop : "static",
				windowClass : 'modal mymodal select-modal select-new-modal',
				templateUrl : $iq_server.client()
						+ 'templates/common/iq_dialogsharefile.html',
				resolve : {
					options : function() {
						return options;
					}
				},
				controller : function($scope, $modalInstance,$timeout,$iq_popup_loadone) {
					$scope.options = options;
					// 创建filter数据
					$scope.allFilter = '';
					$scope.allchecked = false;//是否全选
					// 新建回调数组
					$scope.datalist = [];
					if (options.selectdata) { // 如果传入了list
						$scope.datalist = options.selectdata;
					}
					// 点击切换tab初始化
					$scope.tab1 = true;
					// 获取部门数据
					$scope.data = [];
					// 动态获取人员数据
					$scope.peopledata = [];
					$scope.personRestore = {};
          $scope.isHasFileData = false;
          //数据量大时不显示数据--人员
					$scope.isShowFilePerson = false;
					//数据量大时不显示数据--部门
					$scope.isShowFileDept = false;
					// 在查询人员之前先请求判断人数，若人数过大>1500则不显示所有，而手动查询
					var popSelectFilePersonFun = function() {
						var func = {
							success : function(re) {
								if(re.data.data <= 1500){
									$scope.isShowFilePerson = false;
									$iq_popup_loadone.loadone('departments/status-filter:1/tree').then(function(re) {
														$scope.data = angular.copy(re);
													}, function() {
														return;
													})
									$iq_popup_loadone
											.loadone('persons/all-active?up_executive=1')
											.then(function(re) {
												$scope.peopledata = angular.copy(re);
												relinkPerson($scope.peopledata,$scope.personRestore);
												// 处理带入数据的选中状态
												if ($scope.datalist.length > 0) {
														for (var j = 0; j < $scope.datalist.length; j++) {
															var peop = $scope.personRestore[$scope.datalist[j].id];
															if(peop){
																peop.flag = 1;
																$scope.datalist[j] = peop;
															}
														}
													}
											}, function() {
												return;
											})
								}else{
									$scope.isShowFilePerson = true;
								}
							}
						}
						var params = {
							method : "GET",
							url : $iq_server.server() + "persons/count"
						}
						$iq_http.http(params, func);
					}
					popSelectFilePersonFun();
					// 获取部门数据
					$scope.deptdata = [];
					// 创建过滤所有节点的数组
					$scope.checkdata = [];
					$scope.restoreData = {};
					//无搜索条件查询部门
					var popSelectFileDeptFun = function() {
						var func = {
							success : function(re) {
								$scope.deptMore = re.data.data;
								if(re.data.data <= 300){
									// isOpen:根据部门数量的大小判断是否展开折叠
									$scope.isOpen = true;
									$scope.isShowFileDept = false;
									$iq_popup_loadone
											.loadone('departments/status-filter:1/tree')
											.then(function(re) {
												$scope.deptdata = angular.copy(re);
												relinkDeptTree($scope.deptdata,$scope.restoreData);
												if ($scope.datalist.length > 0) {
														for (var j = 0; j < $scope.datalist.length; j++) {
															var dept = $scope.restoreData[$scope.datalist[j].id];
															if(dept){
																dept.flag = 1;
																$scope.datalist[j] = dept;
															}
														}
													}
													//展开所有第一级
													for(var i = 0;i<$scope.deptdata.length;i++){
														$scope.deptdata[i].isExpanded = true;
													}

											}, function() {
												return;
											})
								}else{
									$scope.isOpen = true;
									$iq_popup_loadone
									.loadone('departments-root/status-filter:1')
									.then(function(re) {
										$scope.deptdata = angular.copy(re);
										relinkDeptTree($scope.deptdata,$scope.restoreData);
											if ($scope.datalist.length > 0) {
												for (var j = 0; j < $scope.datalist.length; j++) {
													var dept = $scope.restoreData[$scope.datalist[j].id];
													if(dept){
														dept.flag = 1;
														$scope.datalist[j] = dept;
													}
												}
											}
									}, function() {
										return;
									})
								}
							}
						}
						var params = {
							method : "GET",
							url : $iq_server.server() + "departments/count"
						}
						$iq_http.http(params, func);
					}
					//选部门组件,如果有子部门，且没有获取过子部门
					$scope.dept_expand_toggle = function(node) {
						if(node.sub && (!node.subDept || node.subDept.length<0)){
							$iq_popup_loadone.loadone('department/'+node.id+'/children/status-filter:1').then(function(re) {
									node.subDept = angular.copy(re);
									relinkDeptTree(node.subDept,$scope.restoreData);
									if ($scope.datalist.length > 0) {
										for (var j = 0; j < $scope.datalist.length; j++) {
											var dept = $scope.restoreData[$scope.datalist[j].id];
											if(dept && dept!=$scope.datalist[j]){
												dept.flag = 1;
												$scope.datalist[j] = dept;
											}
										}
									}
								}, function() {
									return;
								})

						}
					}
					// 点击折叠或展开列表
					$scope.toggle1 = true;
					$scope.toggle2 = false;
					if ($scope.open) {
						$scope.toggle2 = $scope.open;
					}
					$scope.toggleclick = function(e) {
						this.toggle1 = !this.toggle1;
						this.toggle2 = !this.toggle2;
						if (e.stopPropagation) {
							e.stopPropagation(); // 标准浏览器的
						} else {
							e.cancelBubble = true; // IE浏览器
						}
					}
					// 点击折叠或展开未激活部门
					$scope.nodestatus = function(node) {
						if (node.status == 0) {
							return false;
						} else if (node.status == 1) {
							return true;
						}
					}
					// 人员点击添加到datalist数组
					$scope.peopleclick = function(node) {
						if (node.flag == 1) {
							$scope.clearone(findIndex(node,$scope.datalist));
						} else {
							node.flag = 1;
							$scope.datalist.push(node);
						}
					}
					// 部门点击添加到datalist数组
					$scope.deptnodeclick = function(node) {
						if (node.flag == 1) {
							$scope.clearone(findIndex(node,$scope.datalist));
						} else {
							node.flag = 1;
							$scope.datalist.push(node);
						}
					}
					// 点击ichech添加到datalist数组
					$scope.icheck = function(val) {
						if (val.flag == 0) {
							$scope.clearone(findIndex(val,$scope.datalist));
						} else if (val.flag == 1) {
							$scope.datalist.push(val);
						}
					}
					$scope.allicheck = function(data){
						var checkf = false;
						for(var i=0; i<$scope.peopledata.length;i++){
							if($scope.peopledata[i]!=undefined && $scope.peopledata[i]!=null && $scope.peopledata[i].department!=undefined && $scope.peopledata[i].department!=null){
								if(!data.allchecked&&data.id == $scope.peopledata[i].department.id&&($scope.peopledata[i].flag==undefined||$scope.peopledata[i].flag==0)){
									checkf = true;
									$scope.peopledata[i].flag = 1;
									$scope.datalist.push($scope.peopledata[i]);
								}else if(data.allchecked){
									checkf = false;
									for(var x = 0;x<$scope.datalist.length;x++){
										if($scope.peopledata[i].id == $scope.datalist[x].id&&data.id == $scope.peopledata[i].department.id){
											$scope.peopledata[i].flag = 0;
											var tmp = $scope.datalist[x];
											$scope.datalist[x] = $scope.datalist[$scope.datalist.length-1];
											$scope.datalist[$scope.datalist.length-1] = tmp;
											$scope.datalist.pop();
										}
									}
								}
							}
						}
						if(checkf){
							data.allchecked = true;
						}else{
							data.allchecked = false;
						}
					}
          // 人员搜索
					$scope.selectPerson = function(person){
						if(person.length > 0){
							$scope.data = [];
							$scope.peopledata = [];
							this.isShowFilePerson = false;
							var personSelect = function(person){
								var func = {
									success : function(re) {
										if(person != $scope.allFilter){
											return;
										}
										if(re.data.data.content.length > 0){
											$scope.isHasFileData = false;
											$scope.peopledata = re.data.data.content;
											relinkPerson($scope.peopledata,$scope.personRestore);
											if ($scope.datalist.length > 0) {
												for (var j = 0; j < $scope.datalist.length; j++) {
													var peop = $scope.personRestore[$scope.datalist[j].id];
													if(peop){
														peop.flag = 1;
														$scope.datalist[j] = peop;
													}
												}
											}
										}
										if(re.data.data.content.length == 0){
											$scope.peopledata = [];
											$scope.data = [];
											$scope.isHasFileData = true;
											$scope.isShowFilePerson = false;
											$scope.isHasFileData = true;
										}
									},
									error: function(e) {
										console.log(e);
									}
								}
								var params = {
									method : "GET",
									url : $iq_server.server() + "persons?search_EQ_status_0=1&pageSize=40&sort=ASC_pinyin&up_executive=1&search_Like_name_1="+ person +"&search_Like_itcode_2="+ person +"&formula=0 AND ( 1 OR  2)"
								}
								$iq_http.http(params, func);
							}
							personSelect(person);
						}else{
							$scope.data = [];
							$scope.peopledata = [];
							// $timeout(function() {
							popSelectFilePersonFun();
							// }, 500);
						}

					}
					// 点击切换tab事件
					$scope.tabchange = function(tab) {
						if (tab == 1) {
							$scope.tab1 = true;
							$scope.allFilter = ''; // 清空搜索项
						} else {
							$scope.tab1 = false;
						};
						if (tab == 2) {
							$scope.tab2 = true;
							$scope.allFilter = ''; // 清空搜索项
              //数据量大时不显示数据--部门
              //数据量大时不显示数据--部门
							$scope.isShowFileDept = false;
							// 在查询人员之前先请求判断人数，若人数过大则不显示所有，而手动查询
							popSelectFileDeptFun();
						} else {
							$scope.tab2 = false;
						}
						if (tab == 3) {
							$scope.tab3 = true;
							$scope.allFilter = ''; // 清空搜索项
							// 创建过滤所有节点的数组
							$scope.checkdata = [];
							// 获取群组数据
							$scope.teamdata = [];
							$iq_popup_loadone
									.loadone('groups?page=1&pageSize=99999999')
									.then(function(re) {
										$scope.teamdata = angular.copy(re);
										// 处理带入数据的选中状态
										if ($scope.datalist.length > 0) {
											for (var i = 0; i < $scope.teamdata.length; i++) {
												var nodeobj = $scope.teamdata[i];
												for (var j = 0; j < $scope.datalist.length; j++) {
													var withobj = $scope.datalist[j];
													if (withobj.id == nodeobj.id) {
														nodeobj.flag = 1;
													}
												}
											}
										}
									}, function() {
										return;
									})
							// 点击添加到datalist数组
							$scope.teamnodeclick = function(node) {
								if (node.flag == 1) {
									$scope.clearone(findIndex(node,
											$scope.datalist)); // 标记位
								} else {
									node.flag = 1;
									$scope.datalist.push(node);
								}
							};
						} else {
							$scope.tab3 = false;
						}
						if (tab == 4) {
							// 切换到文件选项
							$scope.tab4 = true;
							$scope.allFilter = ''; // 清空搜索项
							// 创建过滤所有节点的数组
							$scope.checkdata = [];
							// 获取文件数据
							$scope.filedata = []
							$iq_popup_loadone
									.loadone('netdisk/common/dirstree?type=COM')
									.then(function(re) {
										$scope.filedata = angular.copy(re);
										getallfilenode($scope.filedata,
												$scope.checkdata);
										// 处理带入数据的选中状态
										if ($scope.datalist.length > 0) {
											for (var i = 0; i < $scope.checkdata.length; i++) {
												var nodeobj = $scope.checkdata[i];
												for (var j = 0; j < $scope.datalist.length; j++) {
													var withobj = $scope.datalist[j];
													if (withobj.id == nodeobj.id) {
														nodeobj.flag = 1;
													}
												}
											}
										}
									}, function() {
										return;
									})
							// 点击添加到datalist数组
							$scope.filenodeclick = function(node) {
								if (node.id == "deny") {
									return;
								} else {
									if (node.flag == 1) {
										$scope.clearone(findIndex(node,
												$scope.datalist));
									} else {
										node.flag = 1;
										$scope.datalist.push(node);
									}
								}
							}
							// 点击ichech添加到datalist数组
							$scope.icheckfile = function(val) {
								if (val.flag == 0) {
									$scope.clearone(findIndex(val,
											$scope.datalist));
								} else if (val.flag == 1) {
									$scope.datalist.push(val);
								}
							}
						} else {
							$scope.tab4 = false;
						}
					}
					// 清除单个
					$scope.clearone = function($index) {
						$scope.datalist[$index].flag = 0;
						$scope.datalist.splice($index, 1);
					}
					// 清除全部
					$scope.clearall = function() {
						addFlag0($scope.datalist)
						$scope.datalist = [];
					}
					// 显示文件选项卡
					$scope.detpartment = false;
					$scope.team = false;
					$scope.file = false;
					if (options.showtab) {
						if (options.showtab == 'detpartment') {
							$scope.detpartment = true;
						}
						if (options.showtab == 'team') {
							$scope.team = true;
						}
						if (options.showtab == 'file') {
							$scope.file = true;
						}
					}

					// 点击确定和点击取消
					$scope.ok = function() {
						// 去掉flag属性
						delFlag($scope.datalist)
						// 去掉部门obj中的子部门
						if ($scope.datalist.length > 0) {
							for (var i = 0; i < $scope.datalist; i++) {
								var cur = $scope.datalist[i];
								if (cur.subDept && cur.subDept.length > 0) {
									cur.subDept = [];
								}
							}
						}
						$modalInstance.close($scope.datalist);
					}
					$scope.cancel = function() {
						$modalInstance.dismiss('cancel');
					}
					$scope.close = function() {
						$modalInstance.dismiss('close');
					};
          // 部门搜索
					$scope.deptSelect = function(deptname){
						$scope.deptdata = [];
						$scope.checkdata = [];
						$scope.data = [];
						$scope.isShowFileDept = false;
						if(deptname.length >0){
							var func = {
								success : function(re) {
									if(re.data.data.content.length > 0){
										$scope.deptdata = re.data.data.content;
										$scope.isHasFileData = false;
										relinkDeptTree($scope.deptdata,$scope.restoreData);
										if ($scope.datalist.length > 0) {
											for (var j = 0; j < $scope.datalist.length; j++) {
												var dept = $scope.restoreData[$scope.datalist[j].id];
												if(dept){
													dept.flag = 1;
													$scope.datalist[j] = dept;
												}
											}
										}
									}
									if(re.data.data.content.length == 0){
										$scope.deptdata = [];
										$scope.isHasFileData = true;
									}
								},
								error: function(e) {
									console.log(e);
								}
							}
							var params = {
								method : "GET",
								url : $iq_server.server() + "/departments?search_LIKE_name="+deptname+"&pageSize=40&pageNo=1&childNum=true"
							}
							$iq_http.http(params, func);
						}else if(deptname.length == 0){
							$scope.deptdata = [];
							$scope.checkdata = [];
							popSelectFileDeptFun();
						}
					}
				}
			})
			return modalInstance.result;
	 }

		return {
			sharefilePeople : sharefilePeople,
			sharefile: sharefile
		}

	}

	var plateService = function($iq_http,$iq_server,$q,$iq_dialog){
		//移除
		var removeMembers = function(_plateId,_memberId){
			var removeList = [];
			removeList.push(_memberId);
			var param = {
					"removeList" : removeList
			}
			var params = {
					'method' : 'PUT',
					'url' : $iq_server.server() + 'kanban/kanbans/' + _plateId+'/members',
					'data' : param
			}
			return $iq_http.http(params);
		}
		//退出
		var withdraw = function(_plateId){
			var params = {
					'method' : 'PUT',
					'url' : $iq_server.server() +'kanban/kanbans/'+_plateId+'/withdraw'
			}
			return $iq_http.http(params);
		}
		//设置管理员，_setAdmin 1：设置 0：取消
		var setKanbanAdmin = function(_plateId,_memberId,_setAdmin){
			var params = {
					'method' : 'PUT',
					'url' : $iq_server.server() + "kanban/kanbans/"+_plateId+"/Admin/"+_memberId+"/"+_setAdmin
			}
			return $iq_http.http(params);
		}
		//移交看板
		var transferOwner = function(_plateId,_transferId){
			var param = {
					"ownerId" : _transferId
			}
			var params = {
					'method' : 'PUT',
					'url' : $iq_server.server() + 'kanban/kanbans/' + _plateId+'/members',
					'data' : param
			}
			return $iq_http.http(params);
		}
		return {
			removeMembers : removeMembers,
			transferOwner : transferOwner,
			setKanbanAdmin : setKanbanAdmin,
			removeMembers : removeMembers,
			withdraw : withdraw
		}
	}

	var app1 = angular.module('iq_common');
	// 可配置独立
	app1.service("$iq_user", ["$iq_server", "$iq_config", "$iq_http", "$q",
					"$iq_queue", "$iq_httpError", $iq_user]);
	app1.service("$iq_permission", ["$iq_http", "$q", "$iq_server",
					$iq_permission]);

	// 可拆分，部分独立
	app1.service("$iq_popup", ["$iqmodal", "$iq_http", "$iq_server",
					"$timeout", "$iqmodal", $iq_popup]);
	// 业务相关，无法独立
	app1.service("$iq_apps", ["$iq_http", "$q", "$iq_server","$iq_queue", $iq_apps]);

	app1.service("$iq_popup_loadone", ["$iq_http", "$q", "$iq_server",
					$iq_popup_loadone])
	app1.service("$notice_service", $notice_service);
	app1.service("$store_service", $store_service);
	app1.service("$iqa_task_common_service", $iqa_task_common_service);
	app1.service("$attention_service", $attention_service);
	app1.service("$discuss_service", $discuss_service);
	app1.service("$blog_service", $blog_service);
	app1.service("$tag_service", $tag_service);
	app1.service("$iq_schedul_service", $iq_schedul_service);
	app1.service("$iq_getUserinfo", ["$iq_server", "$iq_config", "$iq_http",
					"$q", "$iq_queue", $iq_getUserinfo]);
	app1.service("$iq_istore_service", $iq_istore_service);
	app1.service("$iq_pop_select", ["$iq_server", "$iqmodal", "$iq_window",
					"$q", $iq_pop_select]);
	app1.service("$iqaNavigationService", ['$q', '$iq_http', '$iq_server', navigationService]);
	app1.service("$iq_excel",['$iqmodal', '$iq_server', '$iq_popup', '$iq_http' , $iq_excel]);
	app1.service("$faceService",[faceService]);
	app1.service("$userInfo",['$iq_http', '$iq_server', userInfo]);
	app1.service("$iq_dialog",["$iq_http","$iq_server","$iqmodal",iq_dialog]);
	app1.service("$plateService",["$iq_http","$iq_server","$q","$iq_dialog",plateService]);
})();
